// src/stone/illustrations/StonjiPackageIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiPackageIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 80 80",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#00A868", d: "M0 0h80v80H0z" }),
      /* @__PURE__ */ jsx("path", { fill: "#00A868", d: "M80 0H0v80h80z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#20252A",
          d: "M70.002 60 40 74.999l-29.987-15-.01-40L40 5.002 70.002 20z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#20252A",
          d: "m69.967 20-3.52-1.776-29.982 15 3.52 1.775zM39.984 34.999l-3.55-1.776.015 40L39.984 75z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#20252A", d: "m10.002 20 3.52-1.776 29.982 15-3.52 1.775z" }),
      /* @__PURE__ */ jsx("path", { fill: "#00A868", d: "m39.984 34.999 3.52-1.776.016 40.016-3.536 1.76z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M39.984 38.54v-3.541L69.966 20v3.535zM39.984 38.54v-3.541L10.002 20v3.535z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "m42.07 19.804-7.071-3.536-16.227 8.12 7.07 3.535z" }),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "m25.843 27.923-7.071-3.536v20.418l7.07 3.546z" })
    ]
  }
);
var StonjiPackageIllustration_default = StonjiPackageIllustration;

export {
  StonjiPackageIllustration_default
};
